import { shallowMount } from "@vue/test-utils";
import Contrato from "@/views/Contrato";

jest.mock("vue-pdf-embed/dist/vue2-pdf-embed", () => ({
  __esModule: true,
  default: {
    name: "VuePdfEmbed",
    render: fn => fn("div")
  }
}));

describe("Contrato component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Contrato);
  });

  it("Renders del component Contrato", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
